/**
 * Landing Page Entry Point
 *
 * Inicializa a landing page do SwimSentry.
 * Este arquivo é o entry point processado pelo Vite.
 */

import { LandingPage } from './index';
import '../styles/landing.css';

// Initialize landing page when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const landing = new LandingPage({
    container: '#landing-root',
    videoSrc: '/hero-demo.mp4',
    onTryFree: () => {
      // Navigate to app
      window.location.href = '/app.html';
    },
    onGetPro: () => {
      // Navigate to checkout (placeholder)
      alert('Checkout coming soon! For now, try the free version.');
      window.location.href = '/app.html';
    }
  });

  landing.render();

  // Track page view
  if (typeof (window as any).gtag !== 'undefined') {
    (window as any).gtag('event', 'page_view', {
      page_title: 'Landing Page',
      page_location: window.location.href
    });
  }

  // Handle direct app access via hash
  if (window.location.hash === '#app') {
    window.location.href = '/app.html';
  }
});
